import React, { Component, Fragment } from 'react'
import { observer, inject } from 'mobx-react'
import { observable, action, makeObservable } from 'mobx'
import { Helmet } from 'react-helmet'

import PageNotFound from 'ui/page-not-found/PageNotFound'
import { LoadingMask } from '@elo-kit/components/loading-mask/LoadingMask'

import { snakeCaseToCamelCase } from 'utils/nameStyle.utils'
import { DEFAULT_FALLBACK_LOCALE } from 'constants/locale.constants'

import { fetchItem } from '../api/landingPages.api'

@inject('appStore')
@observer
class CustomLanding extends Component {
  @observable loading = true
  @observable pageExists = false
  @observable item = {}

  constructor(props) {
    super(props)

    makeObservable(this)

    const {
      appStore,
      match: {
        params: { slug },
      },
    } = this.props
    const redirectItem = appStore.useCases.find((item) => item.slug === slug)

    if (redirectItem) {
      window.location.replace(redirectItem.url)
    }
  }

  componentDidMount() {
    const {
      match: {
        params: { slug },
      },
    } = this.props

    fetchItem(slug).then((resp) => this.processResponse(resp))
  }

  componentWillUnmount() {
    const { appStore } = this.props

    appStore.setLayoutSettings({
      hideHeader: false,
      hideFooter: false,
    })
  }

  @action processResponse = ({ data, success }) => {
    const { appStore } = this.props
    const { hideFooter, hideHeader, js } = data || {}

    this.loading = false
    this.item = data
    this.pageExists = success

    if (this.pageExists && js) eval(js)

    appStore.setLayoutSettings({
      hideHeader,
      hideFooter,
    })
  }

  render() {
    if (!this.loading && this.pageExists) {
      const locale = this.item.multilang ? I18n.locale : DEFAULT_FALLBACK_LOCALE

      const {
        css,
        metaImage,
        [snakeCaseToCamelCase(`content_${locale}`)]: content,
        [snakeCaseToCamelCase(`meta_description_${locale}`)]: metaDescription,
        [snakeCaseToCamelCase(`meta_title_${locale}`)]: metaTitle,
      } = this.item

      return (
        <Fragment>
          <Helmet htmlAttributes={{ lang: I18n.locale }}>
            <title>{metaTitle}</title>
            <meta name='description' content={metaDescription} />
            <meta name='image' content={metaImage} />
          </Helmet>
          <style>{css}</style>
          <div className='container-fluid'>
            <div className='row' dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        </Fragment>
      )
    }

    if (!this.loading && !this.pageExists) {
      return <PageNotFound hideGoBack />
    }

    return <LoadingMask />
  }
}

export default CustomLanding
